export default __webpack_public_path__ + "static/media/GTPressura-Regular.4021faf6.woff2";